export default __webpack_public_path__ + "static/media/1923.dceb4ab8.png";